import { useAppSelector } from './hooks';
import { t, Language } from '../i18n';

export const useTranslation = () => {
  const currentLanguage = useAppSelector((state) => state.language.current);

  const translate = (key: string): string => {
    return t(currentLanguage, key);
  };

  return {
    t: translate,
    language: currentLanguage
  };
};
